import { Observable } from 'rxjs';

export abstract class RestoreCartAdapter {
  abstract restoreCart(cartGuid: string): Observable<string>;
}
